import { AppBar, Box, Typography } from '@mui/material';
import { EditSkeleton } from 'components/admin/admin.overlays';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation, useOutletContext, useSearchParams } from 'react-router-dom';
import { useGetPermissionsQuery } from 'store/apis/AccountApi';
import { setHasMarketplace, setPermissions } from 'store/slices/appSlice/AppSlice';

export default function OrderManagement() {
  const dispatch = useDispatch();
  const currentUserData = useOutletContext();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('orderId');
  // orderId is absent for both the list page and a new order, so route path distinguishes them
  const isOrderPage = location.pathname.includes('/residents/order/');

  const { data: permissions, isFetching: permissionsLoading } = useGetPermissionsQuery();
  
  useEffect(() => {
    if (permissions?.length) {
      dispatch(setPermissions(permissions));
      dispatch(setHasMarketplace(permissions.includes("Marketplace")));
    }
  }, [permissions]);

  const headerText = !isOrderPage
    ? "ORDER MANAGEMENT"
    : orderId
      ? "REVIEW/EDIT ORDER"
      : "ADD ORDER";


  return (
    <>
      {permissionsLoading ? (
        <EditSkeleton />
      ) : (
        <>
          <AppBar
            position="static"
            sx={{
              borderRadius: "0 !important",
              borderTop: "1px solid lightgray",
              boxShadow: "4px 4px .5rem rgba(0, 0, 0, .35) !important"
            }}
          >
            <Box
              sx={{
                backgroundColor: "#01617e",
                padding: ".5rem"
              }}
            >
              <Typography
                variant="h6"
                textAlign="center"
                fontWeight="bold"
              >
                {headerText}
              </Typography>
            </Box>
          </AppBar>
          <Outlet context={currentUserData} />
        </>
      )}
    </>
  );
}